var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardDoubleArrowUp24DpFill0Wght400Grad0Opsz24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m296-224-56-56 240-240 240 240-56 56-184-183-184 183Zm0-240-56-56 240-240 240 240-56 56-184-183-184 183Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardDoubleArrowUp24DpFill0Wght400Grad0Opsz24);
export default __webpack_public_path__ + "static/media/keyboard_double_arrow_up_24dp_FILL0_wght400_GRAD0_opsz24.b5d00926162fa68a1db33ef1a5bd0806.svg";
export { ForwardRef as ReactComponent };